import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

class FormattedHeading extends Component {
  render() {
    return (
      <FormattedMessage id={this.props.id}>
        {txt => <h2 className={this.props.className}>{txt}</h2>}
      </FormattedMessage>
    );
  }
}

FormattedHeading.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(FormattedHeading);
